import Navigation from '@/blocks/Navigation';
import PreviewElement from '@/components/Preview';
import Head from '@/elements/Head';
import { getStory } from '@/lib/backend/getStory';
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';

const Preview = (props: any) => {
  const router = useRouter();
  return (
    <div>
      <Head />
      <Navigation entry={props.entry} company={props?.company} />
      {
        <PreviewElement
          {...props}
          placement={router.query.placement || null}
          url={`${router.asPath.split('?')[0]}/story`}
          autoplay={router.query?.autoplay === '1'}
          app={router.query?.app === '1'}
        />
      }
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { params } = context;

  const id = params?.pid as string;
  const entry = (await getStory(id)) as any;

  if (!entry || entry?.status === 'archived') {
    return {
      notFound: true,
    };
  }

  // const related = await getRelated(entry.channel[0].id, params.pid)
  const locale = entry?.brand?.language || 'nl';
  const translations = await serverSideTranslations(locale, ['common']);
  const companies = entry?.brand?.companies || [];

  return {
    props: {
      entry: entry,
      // get the first company and check if companies is set
      company: companies[0]?.companies_id || null,
      // related: related,
      ...translations,
    },
  };
};

export default Preview;
